var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-divider',{staticClass:"mt-10 mb-10"},[_vm._v(" Broker Information ")]),_c('add-broker-component',{attrs:{"broker-data-prop":null}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }